import { entryPoint } from "./shared_entry";
import ForgotPasswordPage from "../app/containers/forgot_password_page";

entryPoint(ForgotPasswordPage, {}, { noGlobalWrap: true, useRedux: true });
